import { createTheme } from '@mui/material/styles'

export const theme = createTheme({
  palette: {
    primary: {
      main: '#2C7A7B',
      contrastText: '#fff',
    },
  },
})
